// Copyright (c) Docugami, Inc. All rights reserved.

import { AuthenticationActionTypes, SET_ERROR_ENOUNTERED, SET_USER_ROLES_PER_ORG } from "./types";
import { Telemetry } from 'telemetry/TelemetryManager';

export function reportErrorEncountered(action: string, error: Error | null): AuthenticationActionTypes {
    let showErrorDialog = false;

    if (action || error) {
        showErrorDialog = true;
        console.log(`${action} Failed: ${error}`);

        try {
            if (!!error) {
                Telemetry.trackException(error)
            }
        }
        catch (err) {
            console.error(`Failed to trackException: ${err}`);
        }
    }

    return {
        type: SET_ERROR_ENOUNTERED,
        payload: showErrorDialog
    }
}

export function setUserRolesPerOrg(userRolesPerOrg: { [orgId: string]: string[] }): AuthenticationActionTypes {
    return {
        type: SET_USER_ROLES_PER_ORG,
        payload: userRolesPerOrg
    }
}
